import ShopRequest from '@/http/ShopRequest'
import ErrorResponseHandler from '@/utility/ErrorResponseHandler'

const shop = {
  namespaced: true,
  state: {
    shops: [],
    groupToShops: [], // グループに紐づく店舗リスト
    shopToGroups: [], // 店舗に紐づくグループリスト
  },
  getters: {
    getShops: (state) => {
      return state.shops
    },
    getShopById: (state) => (id) => {
      const shop = state.shops.list.find((shop) => {
        return shop.id === id
      })
      return shop || null
    },
    getGroupToShops: (state) => {
      return state.groupToShops
    },
    getShopToGroups: (state) => {
      return state.shopToGroups
    },
  },
  actions: {
    getShops: ({ commit }) => {
      const request = new ShopRequest()
      request
        .getList()
        .then((res) => {
          commit('setShops', res.data)
        })
        .catch((err) => {
          ErrorResponseHandler.redirectErrorPage(err.response)
        })
    },
    getGroups: ({ commit }) => {
      const request = new ShopRequest()
      request
        .getGroups()
        .then((res) => {
          commit('setGroups', res.data)
        })
        .catch((err) => {
          ErrorResponseHandler.redirectErrorPage(err.response)
        })
    },
  },
  mutations: {
    setShops(state, shops) {
      state.shops = shops
    },
    setGroups(state, response) {
      state.groupToShops = response.groups
      state.shopToGroups = response.shops
    },
  },
}

export default shop
